import React, {useEffect, useState} from "react";
import {deleteResource, getByIdResource} from "../../service/http-service";
import './ProfileSegmentStyle.css'
import DeleteModal from "../../ui/DeleteModal";
import Edit from '../../../assets/img/profile-images/Uredi-icon.png';
import Delete from '../../../assets/img/profile-images/Izbrisi-icon.png';
import Plus from '../../../assets/img/profile-images/Otvori-icon.png';
import Minus from '../../../assets/img/profile-images/Zatvori-icon.png';
import {GenericEditModalForm} from "./GenericEditModalForm";


export const ProfileExperienceSegment = ({candidate, isPreview}) => {

    const [resultListEmpty, setResultListEmpty] = useState(true);
    const [showOneElement, setShowOneElement] = useState(true);
    const [firstElementFromList, setFirstElementFromList] = useState({})
    const [candidateExistingList, setCandidateExistingList] = useState([]);
    const [updateWorkExperiences, setUpdateWorkExperiences] = useState(false)



    const [entity, setEntity] = useState({candidate: candidate});
    const [addEntity, setAddEntity] = useState(false);
    const [updateEntity, setUpdateEntity] = useState(false)


    const getCandidateExistingList = () => {
        getByIdResource('candidates_experience/get_by_candidate', candidate.id).then(data => {
            setCandidateExistingList(data.data);
            setFirstElementFromList(data.data[0])
            if(data.data && data.data.length > 1){
                if(isPreview){
                    setShowOneElement(false);
                }
                setResultListEmpty(false)
            } else if(data.data && data.data.length === 1){
                setResultListEmpty(false)
            }else {
                setResultListEmpty(true);
            }
        })
    }
    const confirmDelete = (data, url, refreshEntity, setRefreshEntity) => {
        deleteResource(url, data).then(() =>{
            setRefreshEntity(!refreshEntity);
        }).catch((error) => {
            console.log('error')
        })
    }
    useEffect(()=> {
        getCandidateExistingList();
    },[])

    useEffect(() => {
        getCandidateExistingList()
    }, [updateEntity, updateWorkExperiences])

    return(
        <div className='profile_segment_main_container'>
            {(firstElementFromList && candidateExistingList && candidateExistingList.length > 0) && showOneElement ?
                <div className='profile_segment_separate_info d-flex justify-content-between'>
                    <div>
                        {firstElementFromList.company &&  <h5>Компанија: {firstElementFromList.company &&
                            firstElementFromList.company}</h5>}
                        {(firstElementFromList.companyUrl && !firstElementFromList.companyUrl.includes('http')) ?
                            <p>Веб адреса на компанијата: <a href={`https://${firstElementFromList.companyUrl}`} target='_blank'>
                                {firstElementFromList.companyUrl}</a></p> :
                            (firstElementFromList.companyUrl) && <p>Веб адреса на компанијата: <a href={firstElementFromList.companyUrl} target='_blank'>
                                {firstElementFromList.companyUrl}</a></p>}
                        {firstElementFromList.country && <p>Држава: <span>
                        {firstElementFromList.country && firstElementFromList.country.name}</span></p>}
                        {firstElementFromList.place && <p>Општина: <span>
                        {firstElementFromList.place && firstElementFromList.place.name}
                    </span></p>}
                        {firstElementFromList.workingExperienceCatalog && <p>Област на работно искуство:
                            <span> {firstElementFromList.workingExperienceCatalog.name}</span></p>}
                        {firstElementFromList.workingPosition && <p>Работна позиција:
                            <span> {firstElementFromList.workingPosition}</span></p>}
                        <p>Период : <span>{firstElementFromList.startingMonth}/{firstElementFromList.startingYear} - </span>
                            {firstElementFromList.currentEmployment === true ? <span>Сеуште</span> : <span>{firstElementFromList.endingMonth}/{firstElementFromList.endingYear}</span>}</p>
                        {firstElementFromList.responsibilities && <p>Одговорности: <span>
                        {firstElementFromList.responsibilities}
                    </span></p>}
                    </div>
                    <div className="icons-div justify-self-end">
                       {!isPreview &&  <div className="edit_delete_icons">
                           <img src={Edit} alt="edit" onClick={() => {
                               setShowOneElement(false)
                               setEntity(firstElementFromList)
                               setAddEntity(true)}
                           }/>
                           <DeleteModal btnText={<img src={Delete} alt="delete"/>}  btnClass="apply-btn" confirmDelete={() =>
                               confirmDelete(firstElementFromList, 'candidates_experience', updateWorkExperiences, setUpdateWorkExperiences)}/>
                       </div>}
                   </div>

                </div> :
                candidateExistingList.map(entity => <>
                    <div className='profile_segment_separate_info d-flex justify-content-between' key={entity.id}>
                        <div>
                            {entity.company &&  <h5>Компанија: {entity.company &&
                                entity.company}</h5>}
                            {(entity.companyUrl && !entity.companyUrl.includes('http')) ?
                                <p>Веб адреса на компанијата: <a href={`https://${entity.companyUrl}`} target='_blank'>
                                    {entity.companyUrl}</a></p> :
                                (entity.companyUrl) && <p>Веб адреса на компанијата: <a href={entity.companyUrl} target='_blank'>
                                    {entity.companyUrl}</a></p>}
                            {entity.country && <p>Држава: <span> {entity.country && entity.country.name}</span></p>}
                            {entity.place && <p>Општина: <span> {entity.place && entity.place.name}
                    </span></p>}
                            {entity.workingExperienceCatalog && <p>Област на работно искуство:
                                <span> {entity.workingExperienceCatalog.name}</span></p>}
                            {entity.workingPosition && <p>Работна позиција: <span> {entity.workingPosition}</span></p>}
                            <p>Период : <span>{entity.startingMonth}/{entity.startingYear} - </span>
                                {entity.currentEmployment === true ? <span>Сеуште</span> : <span>{entity.endingMonth}/{entity.endingYear}</span>}</p>
                            {entity.responsibilities && <p>Одговорности: <span>
                        {entity.responsibilities}
                     </span></p>}
                        </div>
                         <div className="icons-div justify-self-end">
                           {!isPreview && <div className="edit_delete_icons">
                               <img src={Edit} alt="edit" onClick={() => {
                                   setShowOneElement(false)
                                   setEntity(entity)
                                   setAddEntity(true)}
                               }/>
                               <DeleteModal btnText={<img src={Delete} alt="delete"/>}  btnClass="apply-btn" confirmDelete={() =>
                                   confirmDelete(entity, 'candidates_experience', updateWorkExperiences, setUpdateWorkExperiences)}/>
                            </div>}
                        </div>
                    </div>
                  <hr/>
               </>
                )}

            {!isPreview && !addEntity && (!showOneElement || resultListEmpty ) && (<div className="profile_add_button mt-3"
                                                                                        onClick={() =>
                                                                                        {setEntity({...entity, candidate: candidate})
                                                                                            setAddEntity(true)}}
            >Додади искуство</div>)}
            {addEntity === true && (<div className="open-form">  <GenericEditModalForm
                type="EXPERIENCE"
                title= {!entity.id ? "Додади искуство" : "Уреди искуство"}
                entity={entity} setEntity={setEntity}
                addEntity={addEntity} setAddEntity={setAddEntity}
                updateEntity={updateEntity} setUpdateEntity={setUpdateEntity}/></div>)}

            {(!isPreview && !resultListEmpty) &&
                <>
                    <div className='profile_plus_container'><hr/>
                        {showOneElement ?  <img src={Plus} alt='plus' onClick={()=> setShowOneElement(false)}/> :
                            <img src={Minus} alt='plus' onClick={()=>{
                                setShowOneElement(true)
                            setAddEntity(false)}
                            }/>}
                    </div>
                </>
            }
        </div>
    )
}